"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var boolean = function boolean(value) {
  if (typeof value === 'string') {
    return ['true', 't', 'yes', 'y', 'on', '1'].includes(value.trim().toLowerCase());
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  return false;
};

exports.boolean = boolean;